import React, { useState } from "react";
import { HXCircleIcon, OnboardDueDateCard } from "@aph/ui-lib-humanx";
import Picker from "@/components/Picker";
import styles from "@/components/PageHome/components/OnboardingSection/Flows/Flows.module.scss";

interface PeriodCycleProps {
  heading?: any;
  description?: any;
  bgIcon?: React.ReactNode;
  ctaText?: string;
  ctaClick: (cycleLength: number) => void;
  ctaBelowText?: any;
  initialValue?: any;
  showEdgeCases?: boolean;
}

const CYCLE_OPTIONS: { value: number; label: string; default?: boolean }[] = [
  { value: 20, label: "Less than 21 days" },
  { value: 21, label: "Around 21 days" },
  { value: 22, label: "Around 22 days" },
  { value: 23, label: "Around 23 days" },
  { value: 24, label: "Around 24 days" },
  { value: 25, label: "Around 25 days" },
  { value: 26, label: "Around 26 days" },
  { value: 27, label: "Around 27 days" },
  { value: 28, label: "Around 28 days", default: true },
  { value: 29, label: "Around 29 days" },
  { value: 30, label: "Around 30 days" },
  { value: 31, label: "Around 31 days" },
  { value: 32, label: "Around 32 days" },
  { value: 33, label: "Around 33 days" },
  { value: 34, label: "Around 34 days" },
  { value: 35, label: "Around 35 days" },
  { value: 36, label: "More than 35 days" },
];

const initialData = {
  heading: {
    prefixText: (
      <span>
        How long is <strong>your average cycle?</strong>
      </span>
    ),
  },
  description: "",
  bgIcon: <HXCircleIcon iconStyle={"style1"} className={styles["bgIconTopRight"]} />,
  ctaText: "Submit",
  ctaBelowText: "",
  initialValue: CYCLE_OPTIONS.find((option) => option.default)?.value,
};

const PeriodCycle: React.FC<PeriodCycleProps> = (props) => {
  const {
    heading = initialData.heading,
    description = initialData.description,
    bgIcon = initialData.bgIcon,
    ctaText = initialData.ctaText,
    ctaClick,
    ctaBelowText = initialData.ctaBelowText,
    initialValue = initialData.initialValue,
    showEdgeCases = true,
  } = props;
  const [option, setOption] = useState<number>(initialValue);

  const handleSubmit = (): void => {
    if (ctaClick && typeof ctaClick === "function") {
      ctaClick(option);
    }
  };

  const handleOptionChange = (date: number): void => {
    setOption(date);
  };

  return (
    <>
      <OnboardDueDateCard
        titleText={heading}
        subTitleText={description}
        backgroundCard={bgIcon}
        middleSection={
          <Picker
            fullWidth={false}
            initialValue={initialValue}
            options={showEdgeCases ? CYCLE_OPTIONS : CYCLE_OPTIONS.slice(1, -1)}
            setOption={handleOptionChange}
          />
        }
        ctaText={ctaText}
        ctaClick={handleSubmit}
        ctaBelowText={ctaBelowText}
      />
    </>
  );
};

export default PeriodCycle;
